<template>
	<ViewLayout>
		<template #header-title>
			{{ headerTitle }}
		</template>
		<template #header-caption>
			{{ headerCaption }}
		</template>
		<template #header-after>
			<slot name="header-after" />
		</template>
		<template #content>
			<div class="cassie-vertical-md mt-1">
				<slot name="content" />
			</div>
		</template>
		<template #footer>
			<slot name="footer" />
		</template>
	</ViewLayout>
</template>
<script>
import ViewLayout from '../../../../../../shared/layouts/view-layout.vue'
export default {
	components: { ViewLayout },
	props: {
		headerTitle: {
			type: String,
			default: null
		},
		headerCaption: {
			type: String,
			default: null
		}
	}
}
</script>
